/*@flow*/
import mapboxgl, { type MapLayerMouseEvent } from 'mapbox-gl';

// Create a popup, but don't add it to the map yet.
const popup = new mapboxgl.Popup({
  closeButton: false,
  closeOnClick: false,
});

type Properties = { [key: string]: any };

export default (fn: (properties: Properties) => any) => ({
  mouseenter: (e: MapLayerMouseEvent) => {
    e.target.getCanvas().style.cursor = 'pointer';
    const features = e.features;
    if (!features) return;
    const feature = features[0];
    if (!feature) return;
    if (feature.type !== 'Feature') return;
    if (feature.geometry.type !== 'Point') return;
    const geometry: GeoJSON$Point = feature.geometry;

    const coordinates = geometry.coordinates.slice();
    const properties = feature.properties;

    // Ensure that if the map is zoomed out such that multiple
    // copies of the feature are visible, the popup appears
    // over the copy being pointed to.
    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
      coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
    }

    // Populate the popup and set its coordinates
    // based on the feature found.
    popup
      .setLngLat(coordinates)
      .setHTML(fn(properties))
      .addTo(e.target);
  },
  mouseleave: (e: MapLayerMouseEvent) => {
    e.target.getCanvas().style.cursor = '';
    popup.remove();
  },
});
